import React from "react";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupModernizations } from "../../../components/Shared/NewForms/NFLookupModernizations";
import FixedAssetsModernizationsDetails from "../../../components/Pages/Documents/FixedAssetsModernizations/FixedAssetsModernizationsDetails";
import { CreateFixedAssetsModernizationDto } from "../../../dtos/documents/FixedAssetsModernizations/CreateFixedAssetsModernizationDto";
import { FixedAssetsModernizationService } from "../../../services/documents/FixedAssetsModernizationService";
import FixedAssetsModernizationsList from "../../../components/Pages/Documents/FixedAssetsModernizations/FixedAssetsModernizationsList";

export const FixedAssetsModernization: IAppEntity = {
  entityType: "document",
  title: "Modernization",
  pluralTitle: "Modernizations",
  apiUrl: "FixedAssetsModernizations",
  apiEnum: ReferenceTypes.DocumentFixedAssetsModernization,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(FixedAssetsModernizationsDetails, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(FixedAssetsModernizationsList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupModernizations, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () =>
    new FixedAssetsModernizationService("FixedAssetsModernizations"),
  getEmptyModel: () => {
    const model: CreateFixedAssetsModernizationDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      status: 0,
      
      documentDate: new Date(),
      createdDate: new Date(),
      fixedAssets:[]
    };
    return model;
  },
};
